import { SHOW_SENT_ORDER_MSG } from "../constants/actionTypes";

export const showSentMsgBox = (show) => {
  return { type: SHOW_SENT_ORDER_MSG, show: show };
};
